import React, { useEffect, useState } from "react";
import { Spinner, Modal, Button } from "react-bootstrap";
import { createInfo, createPrivayPolicy, deletePrivayPolicy, getInfo, getPrivayPolicy, updatePrivayPolicy } from "../../services/Admin/adminServices";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import RichTextEditor from "../components/Common/RichTextEditor";

const hasText = (value) =>
  (value || "").replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim().length > 0;

const PrivacyPolicy = () => {
  const [infos, setInfos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedInfo, setSelectedInfo] = useState(null);
    const [showAdd, setShowAdd] = useState(false);

  // Fetch data (dummy for now, replace with API)
   const fetchData = async () => {
      try {
        const response = await getPrivayPolicy();
        setInfos(response?.data?.data);
      } catch (error) {
        console.error("Error fetching legal info:", error);
      } finally {
        setLoading(false);
      }
    };
  useEffect(() => {
   
    fetchData();
  }, []);

  const handleEditClick = (info) => {
    setSelectedInfo(info);
    setShowModal(true);
  };

  const handleUpdate = async (values) => {
    try {
 


       const payload = { ...values };
    if (!payload.title || payload.title.trim() === "") {
      delete payload.title;
    }


      const res = await updatePrivayPolicy(values);
fetchData()
       toast.success("Updated")
    setSelectedInfo(null);
      setShowModal(false);
    } catch (error) {
    
toast.error(error?.response?.data?.message)
      console.error("error", error.response.data.message);
    }
  };


  const handleNew = async (values) => {
    try {

       const payload = { ...values };
    if (!payload.title || payload.title.trim() === "") {
      delete payload.title;
    }
 
      const res = await createPrivayPolicy(payload);
fetchData()
       toast.success("Added")
   
      setShowAdd(false);
    } catch (error) {
      
toast.error(error?.response?.data?.message)
      console.error("error", error.response.data.message);
    }
  };




  const handleAdd = () => {
    setShowAdd(true);
    
  };

  const handleDelte = async (id) => {
    try {
      await deletePrivayPolicy(id);
      fetchData();
      toast.success("Deleted SuccessFully");
    } catch (error) {
      console.error("Delete error:", error);
    }
  };

  return (
    <div className=" ">
      <div className="d-flex justify-content-between mb-3">
        <h2 className="mb-3" style={{color:"#0AB7EA"}}>Privacy Policy</h2>
        <div>
          {/* <button
            className="btn"
            style={{
              backgroundColor: "#0AB7EA",
              color: "white",
              border: "none",
              padding: "8px 16px",
              borderRadius: "4px",
            }}
          onClick={()=>handleAdd()}
          >
            Add new
          </button> */}
        </div>
      </div>

      {loading ? (
        <div className="d-flex justify-content-center my-5">
          <Spinner animation="border" variant="primary" role="status" />
        </div>
      ) : infos?.length === 0 ? (
        <p>No privacy policy available.</p>
      ) : (
        <ul className="list-group">
          {infos?.map((item) => (
            
            <li
              key={item._id}
              className="list-group-item d-flex  flex-column "
              style={{ borderColor: "#0AB7EA" }}
            >
    <div className="d-flex justify-content-between" >  <h2 className="fw-bold  mb-1" >{item.title}</h2>
                

                <div className="d-flex gap-2" >   

                   <button
                  className="btn btn-sm"
                  style={{
                    backgroundColor: "#0AB7EA",
                    color: "white",
                    border: "none",
                  }}
                      onClick={() => handleEditClick(item)}
                >
                  Edit
                </button>
                 {/* <button
                  className="btn btn-sm"
                  style={{
                    backgroundColor: "red",
                    color: "white",
                    border: "none",
                  }}
                      onClick={() => handleDelte(item._id)}
                >
                  Delete
                </button> */}
                </div>
                
                 </div>


              <div className="desc-text" dangerouslySetInnerHTML={{ __html: item.description }} />
            
            </li>
          ))}
        </ul>
      )}

      {/* Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} dialogClassName="rich-editor-modal">
        <Modal.Header closeButton>
          <Modal.Title className="titleColor">Edit Privacy Policy</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={{
            privacyPolicyId: selectedInfo?._id || "",
              title: selectedInfo?.title || "",
            description: selectedInfo?.description || "",
          }}
          enableReinitialize
          validationSchema={Yup.object({
            description: Yup.string()
              .required("Description is required")
              .test("not-empty", "Description is required", hasText),
          })}
          onSubmit={handleUpdate}
        >
          {({ isSubmitting, setFieldValue, values }) => (
            <Form>
      
              <Modal.Body>
                <div className="mb-3">
                     <label htmlFor="title" className="form-label">
              Title
                  </label>
                  <Field
               
                    name="title"
                    id="title"
                  
                    className="form-control"
                    style={{ borderColor: "#0AB7EA" }}
                  />
                  <ErrorMessage
                    name="title"
                    component="div"
                    className="text-danger"
                  />
                  <label htmlFor="description" className="form-label">
                    Description
                  </label>
                  <RichTextEditor
                    value={values.description}
                    onChange={(content) => setFieldValue("description", content)}
                    placeholder="Write the privacy policy..."
                  />
                  <ErrorMessage
                    name="description"
                    component="div"
                    className="text-danger"
                  />

                 
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowModal(false)}>
                  Cancel
                </Button>
                <Button
                  type="submit"
                  style={{ backgroundColor: "#0AB7EA", border: "none" }}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "updating" : "Save Changes"}
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>



{/*add new*/}

    <Modal show={showAdd} onHide={() => setShowAdd(false)} dialogClassName="rich-editor-modal">
        <Modal.Header closeButton>
          <Modal.Title> Add Privacy Policy  </Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={{
           
              title: "",
            description:"",
          }}
          enableReinitialize
          validationSchema={Yup.object({
            description: Yup.string()
              .required("Description is required")
              .test("not-empty", "Description is required", hasText),
          })}
          onSubmit={handleNew}
        >
          {({ isSubmitting, setFieldValue, values }) => (
            <Form>
      
              <Modal.Body>
                <div className="mb-3">
                    <label htmlFor="title" className="form-label">
              Title
                  </label>
                  <Field
               
                    name="title"
                    id="title"
                  
                    className="form-control"
                    style={{ borderColor: "#0AB7EA" }}
                  />
                  <ErrorMessage
                    name="title"
                    component="div"
                    className="text-danger"
                  />
                  <label htmlFor="description" className="form-label">
                    Description
                  </label>
                  <RichTextEditor
                    value={values.description}
                    onChange={(content) => setFieldValue("description", content)}
                    placeholder="Write the privacy policy..."
                  />
                  <ErrorMessage
                    name="description"
                    component="div"
                    className="text-danger"
                  />

                  
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowAdd(false)}>
                  Cancel
                </Button>
                <Button
                  type="submit"
                  style={{ backgroundColor: "#0AB7EA", border: "none" }}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Uploading" : "Save Changes"}
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>






    </div>
  );
};

export default PrivacyPolicy;
